document.addEventListener("DOMContentLoaded", () => {

    /* Disable custom cursor on mobile & touch devices */
    if (
        window.matchMedia("(hover: none), (pointer: coarse)").matches ||
        window.innerWidth < 768
    ) {
        return;
    }

    const cursor = document.createElement("div");

    cursor.id = "harry-cursor";

    const img = document.createElement("img");

    img.src = window.harryCursorImage;

    img.className = "harry-cursor-img";

    img.draggable = false;

    cursor.appendChild(img);

    const flame = document.createElement("div");

    flame.className = "harry-flame";

    cursor.appendChild(flame);

    document.body.appendChild(cursor);

    let mouseX = 0;
    let mouseY = 0;

    let x = 0;
    let y = 0;
    let speed = 0;

    document.addEventListener("mousemove", (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
    });

    function animate() {

        const dx = mouseX - x;
        const dy = mouseY - y;

        speed = Math.sqrt(dx * dx + dy * dy);

        x += dx * 0.65;
        y += dy * 0.65;

        cursor.style.left = x + "px";
        cursor.style.top = y + "px";
        cursor.style.setProperty("--engine", Math.min(speed, 25));

        requestAnimationFrame(animate);
    }

    animate();

    document.querySelectorAll("a, button, .button, input").forEach(el => {

        el.addEventListener("mouseenter", () => {
            cursor.classList.add("hover");
        });

        el.addEventListener("mouseleave", () => {
            cursor.classList.remove("hover");
        });

    });

});